var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 47.5V45C47.5 43.6739 46.8679 42.4021 45.7426 41.4645C44.6174 40.5268 43.0913 40 41.5 40H29.5C27.9087 40 26.3826 40.5268 25.2574 41.4645C24.1321 42.4021 23.5 43.6739 23.5 45V47.5",
    stroke: "#13142A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 35.5C38.8137 35.5 41.5 32.8137 41.5 29.5C41.5 26.1863 38.8137 23.5 35.5 23.5C32.1863 23.5 29.5 26.1863 29.5 29.5C29.5 32.8137 32.1863 35.5 35.5 35.5Z",
    stroke: "#13142A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "black"
  })));
}
export default SvgContactPerson;